import { render, staticRenderFns } from "./List-Invoice-Origin.vue?vue&type=template&id=3c839bb9&scoped=true"
import script from "./List-Invoice-Origin.vue?vue&type=script&lang=js"
export * from "./List-Invoice-Origin.vue?vue&type=script&lang=js"
import style0 from "./List-Invoice-Origin.vue?vue&type=style&index=0&id=3c839bb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c839bb9",
  null
  
)

export default component.exports